export default () => jQuery(($) => {
	$('a.logout-page_post')
		.click(function (event) {
			event.preventDefault();
			let expires = new Date();
			expires.setTime(expires.getTime() - (10 * 24 * 60 * 60 * 1000));
			const key = `wp-postpass_${COOKIEHASH}`;
			const value = '';
			const path = `${COOKIEPATH}`;
			document.cookie = `${key}=${value}; path=${path}; expires=${expires.toUTCString()}`;

			location.reload( true );
		});
});
